import React from 'react';

import { useEscape } from '~/ui/hooks/interaction';

export function withUseEscape(Base) {
  return function WrappedWithUseEscape(props) {
    useEscape(props.onEsc);

    return <Base {...props} />;
  };
}
